export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('TabsBehavior', (tabs) => ({
        activeTab: 0,
        tabs,
        prevTab() {
          if (this.activeTab > 0) {
            this.activeTab--;
            return;
          }
          this.activeTab = this.tabs.length - 1;
        },
        nextTab() {
          if (this.activeTab < this.tabs.length - 1) {
            this.activeTab++;
            return;
          }
          this.activeTab = 0;
        },
        goToTab(index) {
          this.activeTab = index;
        },
      }));
    });
  },
};
